import { PopUpModalType } from "src/app/shared/enums/popup-modal-type";
import { ChatResultStatus } from "./chat-result-status";
import { UsageMeterType } from "src/app/shared/enums/usage-meter-type";


export class ExamGenerationCompletedSignalRMessage {
  examGenerationUniqueID: string;
  status: ChatResultStatus;
  popUpModalType: PopUpModalType;
  popUpModelText: string;
  popupModelMessage: string;
  usageMeterType: UsageMeterType;
  success: boolean;
}

